// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__20rKI","signatureButtonsRight":"ModalSign_signatureButtonsRight__3R9Ve"};